module.exports = __webpack_public_path__ + "main/assets/public/social-icons/facebook.f15097585ed01877.svg";